module.exports = __webpack_public_path__ + "img/hun.0d7409f8.svg";